export default class Search {
  constructor() {
  // check if there is a searchterm
  const urlParams = new URLSearchParams(window.location.search);
  const searchQuery = urlParams.get("tx_solr[q]");

  // jump to heading of filters, if theres a finding
  if (searchQuery) {
    const targetElement = document.querySelector(".tx_solr.egat-search");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  }

  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Search();
});
